import { Route, Routes } from 'react-router-dom';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { SignUpPage, SignUpPersonalPage, SignUpVcfcPage, SuccessPage, SuccessVcfcPage } from '@pages';

export const Public = () => {
  return (
    <Routes>
      {PaletteUtils.isInsigniaPalette && (
        <>
          <Route path={RoutePaths.signup.path} element={<SignUpPage />} />
          <Route path={RoutePaths.success.path} element={<SuccessPage />} />
        </>
      )}
      {PaletteUtils.isVcfcPalette && !PaletteUtils.isPersonalPalette && (
        <>
          <Route path={RoutePaths.signup.path} element={<SignUpVcfcPage />} />
          <Route path={RoutePaths.success.path} element={<SuccessVcfcPage />} />
        </>
      )}
      {PaletteUtils.isPersonalPalette && (
        <>
          <Route path={RoutePaths.signup.path} element={<SignUpPersonalPage />} />
          <Route path={RoutePaths.success.path} element={<SuccessVcfcPage />} />
        </>
      )}
    </Routes>
  );
};
